
import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from 'react-redux'
import _, { size } from 'lodash';
import { Bar, Doughnut, Pie, Scatter } from 'react-chartjs-2';
import { Box, Grid, Typography } from "@mui/material";
import { GetColor } from "./RefColorFunctions";


const ArcListMultiPositive = (props) => {

    const ComponentProperties = props.ComponentProperties
    const { KeyToUse, PositiveValues, MaxValue, Label, DataLabels,ValueLabels, Color, Proportion } = ComponentProperties
    const DataReportData = props.DataReportData
    const KeyToUseArray = KeyToUse ? KeyToUse.split('|') : []
    const PositiveValuesArray = PositiveValues ? PositiveValues.split('|') : []
    const LabelArray = DataLabels ? DataLabels.split('|') : []
    

    const GenerateData = () => {
        let finalArray = []
        // for each key
        for (var i = 0; i < KeyToUseArray.length; i++) {
            // we are going to create an array of 1s and 0s.
            let valArray = DataReportData.map(x => { return PositiveValuesArray.indexOf(x[KeyToUseArray[i]]) >= 0 ? 1 : 0 })
            // send it to the sum function
            let sumOfValues = _.sum(valArray)
            let propOfPositive = Number(parseFloat(sumOfValues / valArray.length * 100)).toFixed(2)
            finalArray.push({ label: LabelArray[i], count: sumOfValues, key: KeyToUseArray[i], proportion: propOfPositive })
        }
        return finalArray
    }

    const BarComponent = ({ obj }) => {
        return (
            <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={1}>
                <Grid item xs={5}>
                    <Typography variant="body2" align="right">{obj.label}</Typography>
                </Grid>
                <Grid item xs={5}>
                    <Box sx={{ px: 2 }}>
                        <Box sx={{ width: "100%", height: "10px", borderRadius: "5px", backgroundColor: GetColor('RYGG VALUE GRADE', 0) + "AA" }}>
                            <Box sx={{ width: obj.proportion + "%", height: "100%", borderRadius: "5px", backgroundColor: GetColor('RYGG VALUE GRADE', 1) }} />
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="body2" align="left">{Math.floor(obj.proportion)}%</Typography>
                </Grid>
            </Grid>
        )
    }

    const ThisData = GenerateData()
    return (
        <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h6" align="center">{Label}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={1}>
                    {
                        ThisData.map(x => {
                            return (
                                <Grid item xs={12}>
                                    <BarComponent obj={x} />
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Grid>

        </Grid>
    )
}

export default ArcListMultiPositive